export const columns = [
  {
    title: "清单名称",
    width: 150,
    key: "name",
    dataIndex: "name",
  },
  {
    title: "预算工程量",
    width: 150,
    key: "count",
    dataIndex: "count",
  },
];
